import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import SortObject from "../../../types/SortObject";
import GroupedBonusModel, { BonusModel } from "../../../viewModels/Deal/BonusModel";
import { UserBasicInfoModel } from "../../../viewModels/User/UserBasicInfoModel";
import { BonusesFiltersType } from "./components/BonusesFilters";
import { CreateBonusFormValues } from "./types";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  loadingWorkers: boolean;
  loadError: boolean;
  page: number;
  pageSize: number;
  bonuses?: Array<GroupedBonusModel>;
  total?: number;
  sort?: SortObject;
  filters?: BonusesFiltersType;

  workers?: Array<UserBasicInfoModel>;
} = {
  loading: true,
  loadingData: true,
  loadingWorkers: true,
  loadError: false,
  page: undefined!,
  pageSize: 20,
};

const accountantBonusesSlice = createSlice({
  name: "accountantBonuses",
  initialState,
  reducers: {
    loadBonuses(state) {
      state.loading = true;
      state.loadingData = true;
      state.loadError = false;
      state.page = 1;
    },
    loadBonusesSuccess(state, action: PayloadAction<{ bonuses: Array<GroupedBonusModel>; total: number }>) {
      const { total, bonuses } = action.payload;

      state.loading = false;
      state.loadingData = false;
      state.loadError = false;
      state.bonuses = bonuses;
      state.total = total;
    },
    loadBonusesReject(state) {
      state.loading = false;
      state.loadingData = false;
      state.loadError = !state.bonuses;
    },

    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort?: SortObject; filters: BonusesFiltersType }>) {
      const { page, pageSize, sort, filters } = action.payload;
      state.loadingData = true;
      state.page = page;
      state.pageSize = pageSize;
      state.sort = sort;
      state.filters = filters;
    },

    loadWorkers(state) {
      state.loadingWorkers = true;
    },
    loadWorkersSuccess(state, action: PayloadAction<Array<UserBasicInfoModel>>) {
      state.loadingWorkers = false;
      state.workers = action.payload;
    },
    loadWorkersReject(state) {
      state.loadingWorkers = false;
    },

    editBonus(state, _action: PayloadAction<{ uuid: string; bonus: BonusModel }>) {
      state.loadingData = true;
    },
    editBonusSuccess(state, action: PayloadAction<{ uuid: string; bonus: BonusModel }>) {
      state.loadingData = false;

      if (state.bonuses) {
        const group = state.bonuses.find((item) => item.uuid === action.payload.uuid);
        const index = group?.bonuses.findIndex((item) => item.id === action.payload.bonus.id);

        if (group && index !== undefined && index !== -1) {
          group.bonuses[index] = action.payload.bonus;
        }
      }
    },
    editBonusReject(state) {
      state.loadingData = false;
    },

    createBonus(state, _action: PayloadAction<CreateBonusFormValues>) {
      state.loadingData = true;
    },
    createBonusSuccess(state) {
      state.loadingData = false;
    },
    createBonusReject(state) {
      state.loadingData = false;
    },
  },
});

export default accountantBonusesSlice;
